<template>
  <div class="npc-query-container">
    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="layui-form-item">
        <div class="layui-input-wrap">
          <div class="layui-input-prefix">
            <i class="layui-icon layui-icon-search"></i>
          </div>
          <input
              type="text"
              v-model="searchQuery"
              placeholder="输入NPC所在地图或名称..."
              class="layui-input"
              lay-affix="clear"
          >
        </div>
      </div>
    </div>

    <!-- 内容区域 - 仅包裹列表，无额外高度占用 -->
    <div class="content-wrapper">
      <!-- NPC列表区域：高度=浏览器高度-160px -->
      <div class="list-section">
        <div class="section-content">
          <div v-if="filteredNpcs.length" class="npc-list">
            <div
                v-for="(npc, index) in filteredNpcs"
                :key="index"
                :class="{ active: selectedNpc === npc }"
                @click="selectNpc(npc)"
            >
              <span style="color:red;">{{ index + 1 }}.</span>{{ npc.c }}-{{ npc.a }}[{{ npc.b }}]
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="fa fa-user-friends"></i>
            <p>暂无NPC数据</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchData } from '@/utils/JSONHelper';
export default {
  data() {
    return {
      searchQuery: '',
      selectedNpc: null,
      npcData: []
    };
  },
  created() {
    // 初始化路由参数
    this.initialItemId = this.$route.query.c_id ? parseInt(this.$route.query.c_id) : null;
    this.getNpcData();
  },
  computed: {
    filteredNpcs() {
      if (!this.searchQuery) return this.npcData;
      const query = this.searchQuery.toLowerCase();
      return this.npcData.filter(npc =>
          npc.a.toLowerCase().includes(query) ||
          npc.c.toLowerCase().includes(query)
      );
    }
  },
  methods: {
    selectNpc(npc) {
      this.selectedNpc = npc;
    },
    async getNpcData() {
      this.loading = true;
      this.error = '';
      try{
        // 并行请求多个接口，减少总等待时间
        const [npcResponse] = await Promise.all([
          fetchData({ type: 'npcs' ,id:this.initialItemId}),  // 物品数据接口
          //fetchData({ type: 'monsters',id:this.initialItemId }),  // 怪物数据接口
          //fetchData({ type: 'maps' }),      // 地图数据接口
          //fetchData({ type: 'monsterRefresh' }) // 怪物刷新数据接口
        ]);

        // 检查响应状态并更新数据
        if (npcResponse.code === 1){
          this.npcData = npcResponse.data || [];
        }


        //if (refreshResponse.code === 1) this.monsterRefresh = refreshResponse.data[0]['c_material'] || [];
      }catch(error){
        console.error('数据获取失败:', error);
        this.error = '数据加载失败，请稍后重试';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* 外层容器：仅控制内边距，不设置固定高度，避免层级冲突 */
.npc-query-container {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden; /* 关键：禁止外层溢出，隐藏浏览器滚动条 */
  margin: 0;
  background-color: #fafafa;
}

/* 搜索区域：固定样式，不占用额外高度 */
.search-section {
  background: white;
  border-radius: 4px;
  margin-bottom: 15px;
  width:33%;
}

.search-section .layui-input {
  border-radius: 4px;
  padding-left: 30px !important;
  height: 30px;
  border: 1px solid #e6e6e6;
}

.search-section .layui-form-item {
  margin: 0;
}
.layui-input-wrap{
  width:100%;
}
.layui-input-prefix {
  color: #888;
  line-height:30px;
}
/* 内容容器：无高度，仅做布局包裹，不干扰列表高度 */
.content-wrapper {
  display: flex;
  gap: 15px;
  overflow: hidden; /* 确保子元素不溢出 */
  width:500px;
}

/* 核心：列表区域高度=浏览器高度-160px */
.list-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  overflow: hidden; /* 裁剪内部内容，避免超出自身高度 */
  background: white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  /* 关键样式：高度跟随浏览器，减去160px（包含搜索区+间距） */
  height: calc(100vh - 160px);
  max-height: calc(100vh - 160px); /* 防止高度异常增大 */
}

/* 列表内容区：占满列表高度，超出滚动 */
.section-content {
  flex: 1; /* 新增：确保内容区占满列表高度 */
  box-sizing: border-box;
  overflow-y: auto; /* 内容超出时显示内部滚动条 */
}

/* Chrome/Safari 滚动条默认隐藏，鼠标悬停时显示 */
.section-content::-webkit-scrollbar {
  width: 0; /* 默认宽度为0，隐藏滚动条 */
  height: 0;
  transition: width 0.3s ease; /* 宽度变化添加过渡效果 */
}

/* 鼠标悬停在内容区域时，显示滚动条 */
.section-content:hover::-webkit-scrollbar {
  width: 2px; /* 显示滚动条，宽度为2px */
  height: 2px;
}

.section-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

.section-content::-webkit-scrollbar-thumb {
  background-color: rgba(156, 156, 156, 0.6);
  border-radius: 10px;
  transition: background-color 0.3s ease;
}

.section-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(100, 100, 100, 0.8);
}

.section-content::-webkit-scrollbar-button {
  display: none;
}

/* Firefox 滚动条美化 - 鼠标悬停显示 */
.section-content {
  scrollbar-width: none; /* 默认不显示滚动条 */
  scrollbar-color: rgba(156, 156, 156, 0.6) transparent;
}

.section-content:hover {
  scrollbar-width: thin; /* 鼠标悬停时显示细滚动条 */
}

/* NPC列表项样式 */
.npc-list div {
  min-height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
}
.npc-list div:hover {
  background-color: #ebf5ff;
}
.npc-list div.active {
  background-color: #e3f2fd;
  color: #1565c0;
  font-weight: bold;
}

/* 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  gap: 10px;
}
.empty-state i {
  font-size: 48px;
  opacity: 0.5;
}

/* 响应式适配：小屏幕保持高度逻辑 */
@media (max-width: 768px) {
  .search-section .layui-input {
    width:100%;
  }
  .search-section{
    width:100%;
  }
  .content-wrapper{
   width:100%;
  }
  .list-section {
    /* 小屏幕保持高度=浏览器高度-160px，避免被遮挡 */
    height: calc(100vh - 160px);
    max-height: calc(100vh - 160px);
  }
}
</style>